import styled from "styled-components";
import Button from "../../../components/style/button/Button";

export const TitleButton = styled(Button)`
  width: 120px;
  height: 48px;
  border: solid 1px var(--gray-4);
  background-color: var(--white);
  margin-left: 8px;
`